import { render } from "./UpgradePackageView.vue?vue&type=template&id=e0b36276&scoped=true"
import script from "./UpgradePackageView.vue?vue&type=script&lang=js"
export * from "./UpgradePackageView.vue?vue&type=script&lang=js"

import "./UpgradePackageView.vue?vue&type=style&index=0&id=e0b36276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b36276"]])

export default __exports__